import { Modal } from "@mantine/core";
import AddMappingForm from "./AddMappingForm";

interface AddMappingModalProps {
  opened: boolean;
  onClose: () => void;
  prefixId: string;
}

export default function AddMappingModal({
  opened,
  onClose,
  prefixId,
}: AddMappingModalProps) {
  // Remount the form on each open so its fields reset without a state-watching effect.
  const formKey = `${prefixId}::${opened ? "open" : "closed"}`;

  return (
    <Modal.Root
      opened={opened}
      onClose={onClose}
      size="md"
      centered
      styles={{
        content: {
          display: "flex",
          flexDirection: "column",
          maxHeight: "85vh",
        },
      }}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Add Mapping</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <AddMappingForm key={formKey} prefixId={prefixId} onClose={onClose} />
      </Modal.Content>
    </Modal.Root>
  );
}
